import { RootState } from "@/store/store";
import { internalOrgQuarterStartMonthSelector } from "@/store/common/selectors/internal/internalOrgQuarterStartMonthSelector";
import { allDateRangesByQuarterStartMonthSelectorCallBack } from "@/store/common/selectors/date-ranges/allDateRangesByQuarterStartMonthSelector";

export const internalAllDateRangesByQuarterStartMonthSelector = (
  state: RootState,
  organisationId: string,
) => {
  const quarterStartMonth = internalOrgQuarterStartMonthSelector(
    state,
    organisationId,
  );

  return allDateRangesByQuarterStartMonthSelectorCallBack(quarterStartMonth);
};
